import { render } from "./RegistroSanitarioEdicion.vue?vue&type=template&id=5a7624d9"
import script from "./RegistroSanitarioEdicion.vue?vue&type=script&lang=js"
export * from "./RegistroSanitarioEdicion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__